import React from "react";
import Banner from "../Banner";
const Header = () => {
    return (
<React.Fragment>
<Banner/>
</React.Fragment>
    );
};

export default Header;